import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  FiSearch,
  FiPlus,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";
import {
  FaBoxes,
} from "react-icons/fa";

const StockOpnamePage = () => {
  const navigate = useNavigate();
  const [stockList, setStockList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(true);

  const [role, setRole] = useState("");
  const [selectedOutlet, setSelectedOutlet] = useState(null);
  const [outlets, setOutlets] = useState([]);

  const fetchOutlets = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/outlet`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      setOutlets(res.data.data || []);
    } catch (err) {
      console.error("Gagal mengambil data outlet:", err);
    }
  };

  const fetchStockOpname = async () => {
    if (!selectedOutlet) return;

    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/stock-opname`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          params: {
            page,
            search: searchTerm,
            outlet_id: selectedOutlet,
            order_by: "created_at",
            sort: "desc",
          },
        }
      );

      const result = res.data;
      setStockList(result.data || []);
      setLastPage(result.meta?.last_page || 1);
      setTotalData(result.meta?.total || 0);
    } catch (error) {
      console.error("Gagal fetch data stock opname:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const userRole = localStorage.getItem("role");
    setRole(userRole);

    if (userRole === "owner") {
      fetchOutlets();
    } else if (userRole === "manager") {
      setSelectedOutlet(localStorage.getItem("id_outlet"));
    }
  }, []);

  useEffect(() => {
    fetchStockOpname();
  }, [page, searchTerm, selectedOutlet]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setPage(1);
  };

  return (
    <main className="flex-1 bg-white rounded-xl p-6 shadow-sm">
      {/* Breadcrumb */}
      <nav className="text-gray-500 text-sm mb-3">
        <ol className="flex items-center gap-2">
          <li className="hover:text-gray-700 transition">Inventory</li>
          <li>/</li>
          <li className="text-gray-700 font-medium">Stock Opname</li>
        </ol>
      </nav>

      {/* Page Title */}
      <h2 className="text-3xl font-bold text-gray-800 mb-4 tracking-tight flex items-center gap-2">
        <span className="text-green-600 text-3xl"> 
          <div className="p-3 bg-green-100 rounded-2xl shadow-inner">
          <FaBoxes className="text-green-600" />
          </div>
          </span> Daftar Stock Opname
      </h2>
      <p className="text-gray-600">Kelola dan pantau semua stock opname dengan mudah</p>
           <br></br>

      {/* Search Section */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4">
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          {/* Search bar */}
          <div className="relative w-full sm:max-w-sm">
            <FiSearch className="absolute left-3 top-3 text-gray-400 text-lg" />
            <input
              type="text"
              placeholder="Cari kode / outlet / pegawai..."
              className="pl-11 pr-4 py-2 w-full rounded-xl border border-gray-300 shadow focus:ring-2 focus:ring-green-400 focus:outline-none transition"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>

          {/* Outlet Dropdown (Owner Only) */}
          {role === "owner" && (
            <div className="relative w-full sm:max-w-xs">
              <select
                className="w-full border border-gray-300 rounded-xl px-4 py-2 shadow focus:ring-2 focus:ring-green-400 focus:outline-none transition"
                value={selectedOutlet || ""}
                onChange={(e) => setSelectedOutlet(e.target.value)}
              >
                <option value="" disabled>
                  Pilih Outlet
                </option>
                {outlets.map((outlet) => (
                  <option key={outlet.id} value={outlet.id}>
                    {outlet.name}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        {/* Create Button */}
        <button
          onClick={() => navigate("/inventory/stock-opname/create")}
          className="flex items-center gap-2 px-4 py-2 bg-green-500 hover:bg-green-600 text-white text-sm font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all"
        >
          <FiPlus className="text-lg" /> Tambah Stock Opname
        </button>
      </div>

      {/* Table */}
      <div className="bg-white border border-gray-200 rounded-xl shadow overflow-hidden">
        <table className="min-w-full bg-white rounded-2xl">
                <thead className="bg-green-50">
            <tr>
              <th className="px-6 py-3 text-left font-semibold text-gray-600">
                Kode
              </th>
              <th className="px-6 py-3 text-left font-semibold text-gray-600">
                Outlet
              </th>
              <th className="px-6 py-3 text-left font-semibold text-gray-600">
                Pegawai
              </th>
              <th className="px-6 py-3 text-left font-semibold text-gray-600">
                Tanggal Dibuat
              </th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan="4"
                  className="px-6 py-4 text-center text-gray-500 italic"
                >
                  ⏳ Memuat data...
                </td>
              </tr>
            ) : stockList.length === 0 ? (
              <tr>
                <td
                  colSpan="4"
                  className="px-6 py-4 text-center text-gray-500 italic"
                >
                  Tidak ada data.
                </td>
              </tr>
            ) : (
              stockList.map((item) => (
                <tr
                  key={item.id}
                  className="hover:bg-gray-50 transition cursor-pointer"
                >
                  <td className="px-6 py-4 font-medium text-gray-700">
                    {item.code}
                  </td>
                  <td className="px-6 py-4">{item.outlet?.name || "-"}</td>
                  <td className="px-6 py-4">{item.employee?.name || "-"}</td>
                  <td className="px-6 py-4 text-gray-600">
                    {new Date(item.created_at).toLocaleString("id-ID", {
                      dateStyle: "medium",
                      timeStyle: "short",
                    })}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col sm:flex-row justify-between items-center mt-5 gap-4">
        <p className="text-gray-500 text-sm">
          Menampilkan <strong>{stockList.length}</strong> dari{" "}
          <strong>{totalData}</strong> data
        </p>

        <div className="flex items-center gap-2">
          <button
            className="flex items-center gap-1 px-4 py-2 rounded-full bg-green-100 hover:bg-green-200 transition disabled:opacity-40"
            onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
            disabled={page === 1}
          >
            <FiChevronLeft /> Prev
          </button>

          <span className="text-gray-700 text-sm">
            Halaman <strong>{page}</strong> / <strong>{lastPage}</strong>
          </span>

          <button
            className="flex items-center gap-1 px-4 py-2 rounded-full bg-green-100 hover:bg-green-200 transition disabled:opacity-40"
            onClick={() => setPage((prev) => Math.min(prev + 1, lastPage))}
            disabled={page === lastPage}
          >
            Next <FiChevronRight />
          </button>
        </div>
      </div>
    </main>
  );
};

export default StockOpnamePage;
